// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__18Tb9","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3SlNJ","gfeWrapper":"CalendarEvent_gfeWrapper__dgS2j"};